import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../styles';

const useStyles = createUseStyles<string, { isExpandable: boolean }>(
  ({ breakpoints }: ITheme) => ({
    root: {
      backgroundColor: '#fff',
      marginInline: 'auto',
      padding: [32, 44, 24, 44],
      width: 'min(1440px, 100%)',

      [mediaQuery(breakpoints.laptop)]: {
        padding: [32, 24, 24],
      },
    },

    row: {
      display: 'flex',

      [mediaQuery(breakpoints.tablet)]: {
        flexDirection: 'column',
      },
    },

    full: {
      flexGrow: 1,
      gap: 74,
      display: 'flex',

      [mediaQuery(breakpoints.laptop)]: {
        gap: 16,
      },

      [mediaQuery(breakpoints.tablet)]: {
        flexDirection: 'column',
        gap: 0,
      },
    },

    termContainer: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',

      '&>section': {
        width: '100%',
        maxWidth: '100%',
      },
    },

    termContainerLast: {
      borderTop: '1px solid var(--x-bg-13)',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      marginBlockStart: 24,
      paddingBlockStart: 20,

      '&>section': {
        maxWidth: '100%',

        '& .footer-batch-link': {
          color: 'var(--x-black)',
          fontSize: 12,
          fontWeight: 600,
          lineHeight: '16px',
          margin: '0px 24px 0 0',
        },
      },
    },

    copy: {
      color: 'var(--x-breadcrumb-last)',
      fontSize: 12,
      fontWeight: 500,
      lineHeight: '16px',
    },

    copyText: {
      borderTop: '1px solid var(--x-bg-13)',
      color: 'var(--x-breadcrumb-last)',
      marginBlockStart: 16,
      paddingBlockStart: 20,
      textAlign: 'center',
      width: '100%',
    },
  }),
  { name: 'SingleToolFooter' },
);

export default useStyles;
